import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BasePaymentService } from '../../http/base-payment.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, map, Observable, switchMap } from 'rxjs';
import { WITHDRAWAL_API } from '../../http/base-http.service';
import { HOST_NAME } from 'src/app/global.tokens';
import { WithdrawalResponse } from './withdrawal.models';
import { PendingWithdrawalService } from './pending-withdrawal.service';

@Injectable({
  providedIn: 'root'
})
export class WithdrawalService extends BasePaymentService {

  private pageTitle = new BehaviorSubject<boolean>(false);
  getPageTitle$ = this.pageTitle.asObservable();


  constructor(http: HttpClient, cookie: CookieService, @Inject(LOCALE_ID) public locale: string, private pendingWithdrawalService: PendingWithdrawalService, @Inject(HOST_NAME) public hostName) {
    super(http, cookie, locale, hostName);
  }

  public getFields(paymentMethodId: number): Observable<{ string }> {
    const url = WITHDRAWAL_API + paymentMethodId
    return super.get<{ string }>(url);
  }
  
  public postWithdraw(withdrawalForm: UntypedFormGroup): Observable<WithdrawalResponse> {
    const url = WITHDRAWAL_API + withdrawalForm.get("payment_id").value;
    return super.postRequest<WithdrawalResponse>(url, withdrawalForm).pipe(
      switchMap(response => {
        return this.pendingWithdrawalService.getList().pipe(
          map(() => response) 
        );
      })
    );
  }

  setPageTitle(value:boolean) {
    this.pageTitle.next(value);
  }
}
